module.exports = __webpack_public_path__ + "img/IMG_2729_L_Wood.92945af5.jpg";